import { render, staticRenderFns } from "./HealthAlert.vue?vue&type=template&id=1d795788&scoped=true&"
import script from "./HealthAlert.vue?vue&type=script&lang=js&"
export * from "./HealthAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d795788",
  null
  
)

export default component.exports